import {
  createBrowserRouter,
  Navigate,
  type RouteObject,
  RouterProvider,
} from 'react-router-dom'
import React from 'react'
import { isFeatureEnabled } from '@/lib/config/feature-flags'

const Layout = React.lazy(() => import('../routes/_layout'))
const Home = React.lazy(() => import('../routes/index'))
const About = React.lazy(() => import('../routes/about/index'))
const Services = React.lazy(() => import('../routes/services/index'))
const Contact = React.lazy(() => import('../routes/contact/index'))
const Store = React.lazy(() => import('../routes/store/index'))
const Cart = React.lazy(() => import('../routes/cart/index'))
const QnA = React.lazy(() => import('../routes/qa/index'))
const Access = React.lazy(() => import('../routes/access/index'))
const Terms = React.lazy(() => import('../routes/terms/index'))
const Privacy = React.lazy(() => import('../routes/privacy/index'))
const Testimonials = React.lazy(() => import('../routes/testimonials/index'))

// Build routes with graceful handling - disabled routes redirect to home
const buildRoutes = (): RouteObject[] => {
  return [
    // Always available routes
    { index: true, element: <Home /> },
    { path: 'contact', element: <Contact /> },
    { path: 'qa', element: <QnA /> },
    { path: 'testimonials', element: <Testimonials /> },
    { path: 'access', element: <Access /> },
    { path: 'terms', element: <Terms /> },
    { path: 'privacy', element: <Privacy /> },

    // Feature-flagged routes with graceful fallback
    {
      path: 'about',
      element: isFeatureEnabled('ABOUT_PAGE_ENABLED') ? (
        <About />
      ) : (
        <Navigate to='/' replace />
      ),
    },
    {
      path: 'services',
      element: isFeatureEnabled('SERVICES_PAGE_ENABLED') ? (
        <Services />
      ) : (
        <Navigate to='/' replace />
      ),
    },
    {
      path: 'store',
      element: isFeatureEnabled('STORE_ENABLED') ? (
        <Store />
      ) : (
        <Navigate to='/' replace />
      ),
    },
    {
      path: 'cart',
      element: isFeatureEnabled('STORE_ENABLED') ? (
        <Cart />
      ) : (
        <Navigate to='/' replace />
      ),
    },

    // Catch-all for unknown routes - redirect to home
    { path: '*', element: <Navigate to='/' replace /> },
  ]
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: buildRoutes(),
    errorElement: (
      <div className='p-6 text-center'>משהו השתבש. אנא נסו שוב.</div>
    ),
  },
])

export function AppRouter(): React.JSX.Element {
  return (
    <React.Suspense fallback={<div className='p-6 text-center'>טוען...</div>}>
      <RouterProvider router={router} />
    </React.Suspense>
  )
}
